import { render, staticRenderFns } from "./PortraitLevel4.vue?vue&type=template&id=0828ecee&scoped=true"
import script from "./PortraitLevel4.vue?vue&type=script&lang=js"
export * from "./PortraitLevel4.vue?vue&type=script&lang=js"
import style0 from "./PortraitLevel4.vue?vue&type=style&index=0&id=0828ecee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828ecee",
  null
  
)

export default component.exports